import dayjs from "dayjs";
import UnderlinedText from "./underlined_text";
import { Grid, Typography } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewIGADistributionCenter = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          color={"white"}
          bgcolor={"red"}
          p={0.5}
          textAlign={"center"}
        >
          Submitted by
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>
          {fieldHeader("Submitted by (Firstname and Lastname)", true)}
        </Grid>
        <UnderlinedText text={data.ldcSubmittedBy} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Submitted date", true)}</Grid>
        <UnderlinedText
          text={dayjs(data.ldcSubmittedDate).format("MM-DD-YYYY")}
        />
      </Grid>
    </>
  );
};

export default ViewIGADistributionCenter;
